import { render, staticRenderFns } from "./PricingTiersDialog.vue?vue&type=template&id=71dbe496"
import script from "./PricingTiersDialog.vue?vue&type=script&lang=ts"
export * from "./PricingTiersDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports